export const FrequencyTypes = {
  DAILY: "daily",
  MONTHLY: "monthly",
  HOURLY: "hourly",
}


// WEBPACK FOOTER //
// ./src/enums/FrequencyTypes.js